export default {
  required: '必填项',
  numAndLetter: '必须为数字与字母组合',
  numeric: '必须为数字',
  email: '邮箱格式不正确',
  phone: '手机号格式不正确',
  minLength({ min }) {
    return `最少${min}位字符`
  },
  maxLength({ max }) {
    return `最多${max}位字符`
  },
  equalTo({ length }) {
    return `应为${length}位字符`
  }
}
